import { useQuery } from "@tanstack/react-query";
import queryKeys from "../../constants/queryKeys";
import homeService from "../../services/homeService";

const useVisitAutomationWindow = () =>
    useQuery({
        queryKey: [queryKeys.visitAutomationWindow],
        queryFn: () => homeService.fetchVisitAutomationWindow(),
    });

export default useVisitAutomationWindow;
